<template>
  <div class="box-card"
       id="warter_mark_show_talent">
    <div class="firstPage" id="warter_mark_show_firstPage">
      <div class="content" id="warter_mark_show_content" >
<!--        <div>-->
<!--          经销商：鞍山华宝汽车销售有限公司(4S)&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;职位：总经理-->
<!--        </div>-->
        <div style="text-align: right">
          <el-button type="primary" @click.native="resumeEdit()">编辑简历</el-button>
          <el-button type="primary" @click.native="resumeExportPDF()">下载简历</el-button>
        </div>
        <h1 class="tc">{{$t('talentpool.resume1')}}</h1>
        <!-- 基本信息 -->
        <div class="box">
          <p class="picon"><em class="basicInfo"></em> <span class="basicInfoText">{{$t('talentpool.basicInfo')}}</span>
          </p>
          <div class="clearfix">
            <img
                    :src="dataForm.headurl"
                    alt=""
                    class="fl"
                    style="margin-top:20px;width: 142px;min-height: 100px;max-height: 200px"
            >
            <ul class="fl baseInfo first">
              <li><span>{{$t('talentpool.name')}}</span><em>{{dataForm.name}}</em></li>
              <li><span>{{$t('talentpool.nationality')}}</span><em>{{dataForm.nationalityName}}</em></li>
              <li><span>{{$t('talentpool.nationName')}}</span><em>{{dataForm.nationName}}</em></li>
              <li><span>{{$t('talentpool.idType')}}</span><em>{{dataForm.idType}}</em></li>
              <li><span>{{$t('talentpool.mail')}}</span><em>{{dataForm.mail}}</em></li>
              <li><span>{{$t('talentpool.wechatNo')}}</span><em>{{dataForm.wechatNo}}</em></li>
              <li><span>{{$t('talentpool.firstWorkYear')}}</span><em>{{dataForm.firstWorkYear}}</em></li>
              <li><span>{{$t('talentpool.orgName')}}</span><em>{{dataForm.orgName}}</em></li>
              <li><span>{{$t('talentpool.registeredResidenceName')}}</span><em>{{dataForm.registeredResidenceName}}</em>
              </li>
              <li><span>{{$t('talentpool.workYearsss')}}</span><em>{{dataForm.workYears}}</em></li>
            </ul>
            <ul class="fl baseInfo second">
              <li><span>{{$t('talentpool.gender')}}</span><em>{{dataForm.gender}}</em></li>
              <li><span>{{$t('talentpool.native')}}</span><em>{{dataForm.nativePlaceName}}</em></li>
              <li><span>{{$t('talentpool.birthday')}}</span><em>{{dataForm.birthday}}</em></li>
              <li><span>{{$t('talentpool.idNum')}}</span><em>{{dataForm.idNo}}</em></li>
              <li><span>{{$t('talentpool.phone')}}</span><em>{{dataForm.tel}}</em></li>
              <li><span>{{$t('talentpool.education')}}</span><em>{{dataForm.education}}</em></li>
              <li><span>{{$t('talentpool.bmwJoinDate')}}</span><em>{{dataForm.bmwJoinDate}}</em></li>
              <li><span>{{$t('talentpool.networkJoinDate')}}</span><em>{{dataForm.networkJoinDate}}</em></li>
              <li><span>{{$t('talentpool.liveName')}}</span><em>{{dataForm.liveName}}</em></li>
              <li><span>{{$t('talentpool.bmwYearss')}}</span><em>{{dataForm.bmwAgeYear}}</em></li>
            </ul>
          </div>
        </div>
        <!-- 个人评价 -->
        <div class="box">
          <p class="nowrap picon"><em class="personalValuation"></em> <span class="basicInfoText">{{$t('talentpool.personalValuation')}}</span>
          </p>
          <div class="skill">
            <ul><li class="huanhang" style="margin-left: 30px; height: auto">{{dataForm.personalEvaluation}}</li></ul>
          </div>
<!--          <div class="huanhang">-->
<!--            {{dataForm.personalEvaluation}}-->
<!--          </div>-->
        </div>
        <!-- 工作经历 -->
        <div class="box">
          <p class="picon"><em class="workExperience"></em> <span class="workExperienceText">{{$t('talentpool.workExperience')}}</span>
          </p>
          <div class="ExperienceList">
            <template v-for="(item,i) in dataForm.resumeWorkDtoList">
              <ul class="clearfix "
                  :style="{ marginBottom: i === dataForm.resumeWorkDtoList.length-1 || dataForm.resumeWorkDtoList.length === 1 ? '0px' : '20px' }"
                  :key="i">
                <li><span>{{$t('talentpool.startDate')}}</span><em>{{item.startDate}}</em></li>
                <li><span>{{$t('talentpool.endDate')}}</span><em>{{item.endDate}}</em></li>
                <li><span>{{$t('talentpool.industryName')}}</span><em>{{item.industryName}}</em></li>
                <li><span v-if="!(item.brandCodeName === '' || item.brandCodeName === null || item.brandCodeName === undefined) ">{{$t('talentpool.brandCode')}}</span><em>{{item.brandCodeName}}</em></li>
<!--                <li><span>{{$t('talentpool.brandCode')}}</span><em>{{item.brandCodeName}}</em></li>-->
                <li><span>{{$t('talentpool.company')}}</span><em>{{item.company}}</em></li>
                <li><span>{{$t('talentpool.job')}}</span><em>{{item.job}}</em></li>
                <li style="width: 100%"><span style="min-width: 22.5%">{{$t('talentpool.jobDescription')}}</span><em style="word-break: break-all;;">{{item.jobDescription}}</em></li>
              </ul>
              <div style="height: 20px;"></div>
            </template>
          </div>
        </div>
        <!-- 所获认证 -->
        <div class="box">
          <p class="nowrap picon"><em class="certified"></em> <span
                  class="certifiedText">{{$t('talentpool.certified')}}</span>
          </p>
          <el-table
                  :data="dataList"
                  border
                  style="width: 70%;"
                  :cell-style="tableCellStyle"
                  :header-cell-style="tableHeaderCellStyle"
          >
            <el-table-column
                    prop="certificateName"
                    :label="$t('talentpool.certificateName')"
                    header-align="center"
                    align="center"
            >
              <template slot-scope="scope">
                <span
                        v-if="scope.row.archive"
                        @click="viewImage(scope.row)"
                        style="color: #337ab7;cursor: pointer;"
                >{{scope.row.certificateName}}</span>
                <span v-else>{{scope.row.certificateName}}</span>
              </template>
            </el-table-column>
            <el-table-column
                    prop="gradeName"
                    :label="$t('talentpool.gradeName')"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="brandCodeName"
                    :label="$t('talentpool.brandCode')"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="yearGained"
                    :label="$t('talentpool.yearGained')"
                    header-align="center"
                    align="center"
            ></el-table-column>
          </el-table>

        </div>
        <!-- 教育背景 -->
        <div class="box">
          <p class="picon"><em class="educationalBackground"></em> <span class="educationalBackgroundText">{{$t('talentpool.educationalBackground')}}</span>
          </p>
          <div class="ExperienceList">
            <template v-for="(item,i) in dataForm.resumeEducationDtoList">
              <ul class="clearfix"
                  :style="{ marginBottom: i === dataForm.resumeEducationDtoList.length-1 || dataForm.resumeEducationDtoList.length === 1 ? '0px' : '20px' }"
                  :key="i">
                <li><span>{{$t('talentpool.startDate')}}</span><em>{{item.startDate}}</em></li>
                <li><span>{{$t('talentpool.endDate')}}</span><em>{{item.endDate}}</em></li>
                <li><span>{{$t('talentpool.school')}}</span><em>{{item.school}}</em></li>
                <li><span>{{$t('talentpool.educationName')}}</span><em>{{item.educationName}}</em></li>
                <li><span>{{$t('talentpool.major')}}</span><em>{{item.major}}</em></li>
              </ul>
            </template>
          </div>
        </div>
        <!-- 个人技能 -->
        <div class="box">
          <p class="nowrap picon"><em class="personalSkills"></em> <span class="personalSkillsText">{{$t('talentpool.personalSkills')}}</span>
          </p>
          <div class="skill">
            <ul>
              <li>{{$t('talentpool.languageSkills')}} :</li>
              <li class="huanhang" style="margin-left: 30px; height: auto">{{dataForm.languageSkills}}</li>
              <div style="height: 40px"></div>
              <li>{{$t('talentpool.drivingSkills')}} :</li>
              <li class="huanhang" style="margin-left: 30px;; height: auto">{{dataForm.drivingSkills}}</li>
              <div style="height: 40px"></div>
              <li>{{$t('talentpool.computerSkills')}} :</li>
              <li class="huanhang" style="margin-left: 30px;; height: auto">{{dataForm.computerSkills}}</li>
              <div style="height: 40px"></div>
              <li>{{$t('talentpool.otherSkills')}} :</li>
              <li class="huanhang" style="margin-left: 30px;; height: auto">{{dataForm.otherSkills}}</li>
              <div style="height: 40px"></div>
            </ul>
          </div>
        </div>
        <!-- 关键管理岗补充信息 --注释 -->
        <div>
<!--        <div class="box">-->
<!--          <p class="picon"><em class="guanjian"></em> <span class="basicInfoText">关键管理岗补充信息</span></p>-->
<!--          <div class="clearfix">-->
<!--            <ul class="fl baseInfo first">-->
<!--              <li><div class="jiahuan">与申请岗位相关管理经验 :{{dataWork.managerialWorkingYearsName}}</div></li>-->
<!--            </ul>-->
<!--            <ul class="fl baseInfo second">-->
<!--              <li><div class="jiahuan">与申请岗位相关管理经验 :{{dataWork.relatedWorkingYearsName}}</div></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <div class="clearfix">-->
<!--            <ul>-->
<!--              <li><div class="jiahuan">列出上述未包括的与工作相关的证书、培训、或课程。</div></li>-->
<!--              <div class="huanhang">{{dataWork.awards}}</div>-->
<!--              <div style="height: 20px"></div>-->
<!--              <li><div class="jiahuan">请列出您获得的与工作相关的认证或奖励。</div></li>-->
<!--              <div class="huanhang">-->
<!--                {{dataWork.certifications}}-->
<!--              </div>-->
<!--              <div style="height: 20px"></div>-->
<!--              <li><div class="jiahuan">列出上述未包括的与工作相关的证书、培训、或课程。</div></li>-->
<!--              <div class="huanhang">{{dataWork.activities}}</div>-->
<!--              <div style="height: 20px"></div>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
        </div>
        <!-- 工作成就 -->
        <div v-if="false" class="box">
          <p class="picon"><em class="gongzuo"></em> <span class="basicInfoText">工作成就</span></p>
          <div class="clearfix">
            <template v-for="(item,i) in accomplishmentList">
              <ul>
<!--                <li><div class="jiahuan">{{item.name}}</div></li>-->
                <div><div class="jiahuan">{{item.content}}</div></div>
                <div style="height: 10px"></div>
<!--                <li><div class="jiahuan">成就:</div></li>-->
                <div class="huanhang">{{item.situation}}</div>

<!--                <div style="height: 10px"></div>-->
<!--                <li><div class="jiahuan">行动:</div></li>-->
<!--                <div class="huanhang">{{item.action}}</div>-->

<!--                <div style="height: 10px"></div>-->
<!--                <li><div class="jiahuan">结果:</div></li>-->
<!--                <div class="huanhang">{{item.result}}</div>-->
                <div style="height: 30px"></div>
              </ul>
            </template>

          </div>
        </div>
      </div>
      <div class="footer">
        <ul class="clearfix">
          <li class="gray"></li>
          <li class="gold"></li>
          <li class="blue"></li>
          <li class="yellow"></li>
          <li class="deepBlue"></li>
          <li class="deepBlue"></li>
          <li class="gold"></li>
          <li class="blue"></li>
          <li class="deepBlue"></li>
          <li class="gray"></li>
          <li class="gold"></li>
          <li class="blue"></li>
          <li class="yellow"></li>
          <li class="deepBlue"></li>
          <li class="deepBlue"></li>
          <li class="black"></li>
        </ul>
      </div>
    </div>
    <el-dialog
            :visible.sync="isShowImag"
            top="5vh"
            width="95%"
            :close-on-click-modal="false"
    >
      <img
              :src="srcList"
              style="width: 600px;height: 700px;display: block; margin: 0 auto;" alt=""
              @contextmenu.prevent
      />
    </el-dialog>
  </div>
</template>

<script>
  import warterMark from '../modules/talent/warterMarkAcdc'
  import {Decrypt,Encrypt} from '@/utils/aec'
  import AesUtil from "@/utils/aes_utils";

  export default {
    data() {
      let _this = this
      return {
        visible: false,
        dataForm: {},
        dataUserForm: {
          userName: '',
          userCode: '',
          userId: '',
          idcard: '',
          email: '',
          mobile: '',
          orgName: '',
          password: '',
          headurl: '',
          orgType: ''
        },
        dataWork: {},
        accomplishmentList: [],
        dataListLoading: false,
        // 预览图片的地址
        srcList: '',
        isShowImag: false,
        // 行业经验
        jobApplication: _this.enums['jobApplication'],
        userId : JSON.parse(sessionStorage.getItem('v1user_data')).userId
      }
    },
    computed: {
      dataRule() {
        return {}
      }
    },
    watch:{
      accomplishmentList:function(){
        this.$nextTick(function(){
          //方法
          this.setWarterMark()
        });
      }

    },
    mounted() {
      this.getInfo()
      this.$eventHub.$on('sendShowResume', data => {
        console.log('sendShowResume')
        this.getInfo()
      })
    },
    activated() {
      this.getInfo()
    },
    created() {
      // this.getUserInfo()
    },
    methods: {

      // 跳转编辑页面
      resumeEdit() {
      //userid加密
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = '';
      if(this.userId === ''){
        userId = '';
      }else {
        userId = base64url.encode(aes.encrypt(this.userId + ''))
      }
      console.info("userId------"+userId)
        this.$router.push({
          name: 'resumeEdit',
          query: {userId: userId,isAc: '1'}
        })
      },

      // 下载PDF
      resumeExportPDF() {
        this.$request.downloadPDF('/talent/talentpool/exportPDFACDC', '员工简历信息', {
          userIds: Encrypt(this.userId)
          // userId: '277666'
        })
      },
      // 获取信息
      getInfo: function () {

        //userid加密
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = '';
      if(this.userId === ''){
        userId = '';
      }else {
        userId = base64url.encode(aes.encrypt(this.userId + ''))
      }
      console.info("userId------"+userId)

        this.$nextTick(() => {
          this.$request
            .get('/talent/talentpool/queryResumeInfoMT', {
              // userId: this.userId
              userId: userId
            })
            .then((res, total, code, data) => {
              this.dataForm = data.data
              this.dataList = data.data.resumeAuthenticationDtoList

              for (let i = 0; i <data.data.resumeWorkDtoList.length; i++) {
                if(data.data.resumeWorkDtoList[i].brandCode === '90'){
                  this.dataForm.resumeWorkDtoList[i].brandCodeName = data.data.resumeWorkDtoList[i].otherBrandCodeName
                }
              }

              // 证件编码修改
              this.dataForm.idNo = this.idcardFormatter(data.data.idNo)
              // 手机号加密
              this.dataForm.tel = this.mobileFormatter(data.data.tel)
              // 邮箱加密
              this.dataForm.mail = this.emailFormatter(data.data.mail)


              console.log('getInfo'+this.dataForm)
              console.log(this.dataForm)
            })
            .catch(() => {
            })
        })

        // 获取工作成就数据
        // this.$nextTick(() => {
        //   console.log('获取工作成就数据')
        //   this.$request
        //     .post('/acdc/candidate/queryCandidate', {
        //       recruitmentId: '1'
        //     })
        //     .then((res, total, code, data) => {
        //       this.dataWork = data.data
        //       let managerialWorkingYears = data.data.managerialWorkingYears
        //       let relatedWorkingYears = data.data.relatedWorkingYears
        //
        //       let managerialWorkingYearsName = ''
        //       let relatedWorkingYearsName = ''
        //
        //       for (var i = 0; i < this.jobApplication.length; i++) {
        //         let temp = this.jobApplication[i];
        //         if(temp.code === managerialWorkingYears){
        //           managerialWorkingYearsName = temp.name
        //         }
        //         if(temp.code === relatedWorkingYears){
        //           relatedWorkingYearsName = temp.name
        //         }
        //       }
        //
        //       this.dataWork.managerialWorkingYearsName = managerialWorkingYearsName
        //       this.dataWork.relatedWorkingYearsName = relatedWorkingYearsName
        //
        //       this.accomplishmentList = data.data.accomplishmentDTOList
        //       console.log('工作成就接口')
        //       console.log(this.dataList)
        //       console.log(this.accomplishmentList)
        //     })
        //     .catch(() => {
        //       console.log('catch')
        //     })
        // })
      },

      // 证件编号加密 身份证只加密出生日期，护照号保留第一位和后三位
      idcardFormatter(rowIdcard) {
        if (rowIdcard.length === 10) {
          let a = rowIdcard.substring(0, 1)
          let b = rowIdcard.substr(rowIdcard.length - 3)
          let encryption = ''
          for (let i = 0; i < rowIdcard.length - 4; i++) {
            encryption += '⁎'
          }
          return a + encryption + b
        } else if (rowIdcard.length >= 11) {
          let a = rowIdcard.substring(0, 6)
          let b = rowIdcard.substr(rowIdcard.length - 4)
          return a + '⁎⁎⁎⁎⁎⁎⁎⁎' + b
        } else {
          return rowIdcard
        }
      },
      // 手机号加密 只显示后四位
      mobileFormatter(rowMobile) {
        if (rowMobile && rowMobile !== '') {
          let encryption = ''
          for (let i = 0; i < rowMobile.length - 4; i++) {
            encryption += '⁎'
          }
          let mobile = encryption + rowMobile.substr(rowMobile.length - 4)
          return mobile
        } else {
          return rowMobile
        }
      },
      // 邮箱加密 @之前如果超过2位，显示后两位，如果不超过两位，全部隐藏
      emailFormatter(rowEmail) {
        if (rowEmail && rowEmail !== '') {
          let index = rowEmail.split('@')
          let partOne = index[0]
          let partTwo = index[1]
          let encryption = ''
          if (partOne.length <= 2) {
            for (let i = 0; i < partOne.length; i++) {
              encryption += '⁎'
            }
            return encryption + '@' + partTwo
          } else {
            for (let i = 0; i < partOne.length - 2; i++) {
              encryption += '⁎'
            }
            let email = partOne.substring(0, 2) + encryption
            return email + '@' + partTwo
          }
        } else {
          return rowEmail
        }
      },


      // 页面添加水印
      setWarterMark() {
        this.$request
          .post('/talent/talentpool/queryWarterMarkInfo', {})
          .then((res, total, code, data) => {
            this.dataListLoading = false
            console.log('水印')
            warterMark.set(data.data)
          })
          .catch(() => {
            this.dataListLoading = false
          })
      },
      // 查看证书图片
      viewImage(row) {
        this.srcList = ''
        this.isShowImag = true
        this.srcList = row.archive
      },
      // 修改 table cell边框的背景色
      tableCellStyle() {
        return ''
        // return 'border-color: #8fa3c6; border-right: 5px #8fa3c6 solid; border-bottom: 5px solid #8fa3c6; border-left-width: 5px;border-left-style: solid;'
        // return 'border-color: #8fa3c6; border-right: 1px #8fa3c6 solid; border-bottom: 1px solid #8fa3c6; border-left-width: 1px;border-left-style: solid;'
        // return 'border-color: #8fa3c6; border-right: 1px #8fa3c6 solid; border-bottom: 1px solid #8fa3c6; border-left-width: 1px;border-left-style: solid;'
      },
      // 修改 table header cell的背景色
      tableHeaderCellStyle() {
        return 'border-color: #8fa3c6; color: #8fa3c6;background-color: #8fa3c6;'
      }
    }
  }
</script>
<style scoped>
  .clearfix:before,
  .clearfix:after {
    content: "";
    display: table;
  }

  .clearfix:after {
    clear: both;
  }

  .clearfix {
    *zoom: 1;
  }

  ul {
    padding: 0;
    margin: 0;
    font-size: 14px;
  }

  i {
    font-style: normal;
  }

  .picon {
    transform: translateX(-6%);
  }

  .nowrap {
    white-space: nowrap;
  }

  .huanhang {
    word-wrap: break-word;
    word-break: normal;
  }

  .baseInfo {
    width: calc(50% - 101px);
    font-size: 14px;
  }

  .baseInfo.second {
    /*margin-left: 40px;*/
  }

  .baseInfo li {
    /* height: 40px; */
    min-height: 40px;
    white-space: nowrap;
  }

  .first span {
    position: relative;
    display: inline-block;
    text-align: right;
    white-space: nowrap;
    width: 55%;
    padding-right: 5%;
  }

  .second span {
    position: relative;
    display: inline-block;
    text-align: right;
    white-space: nowrap;
    width: 75%;
    padding-right: 5%;
  }

  .baseInfo span::after {
    position: absolute;
    content: ":";
    right: 0;
  }

  .baseInfo i {
    display: inline-block;
    width: 65%;
    padding-left: 4%;
    box-sizing: border-box;
    white-space: pre-wrap;
    vertical-align: middle;
    word-wrap: break-word;
  }

  li {
    list-style: none;
  }

  .firstPage {
    width: 60%;
    margin: 0 auto;
    /*background: url("../../assets/img/简历背景图.jpg") no-repeat center;*/
    background-size: 100% 100%;
  }

  .content {
    padding: 20px 8%;
    width: 100%;
    height: 100%;
    border: 1px solid #c7c7c7;
    border-radius: 5px;
  }

  .tc {
    text-align: center;
  }

  .fl {
    float: left;
  }

  .firstPage h1 {
    position: relative;
    padding-top: 100px;
    padding-bottom: 30px;
    font-weight: 700;
    font-size: 35px;
  }

  .firstPage h1:after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    background: url("../../assets/img/BMW_Grey-Colour_RGB.png") no-repeat center;
    background-size: 100% 100%;
    width: 60px;
    height: 60px;
  }

  .basicInfo,
  .personalValuation,
  .workExperience,
  .certified,
  .educationalBackground,
  .guanjian,
  .gongzuo,
  .personalSkills {
    display: inline-block;
    content: "";
    width: 20px;
    height: 20px;
    background: url("../../assets/img/1jibenxinxi.png") no-repeat center;
    background-size: 100% 100%;
  }

  .personalValuation {
    background-image: url("../../assets/img/2gerenpingjia.png");
  }

  .workExperience {
    background-image: url("../../assets/img/3gongzuojingli.png");
  }

  .certified {
    background-image: url("../../assets/img/4suohuorenzheng.png");
    /*width: 4%;*/
    /*margin: 0 1%;*/
  }

  .educationalBackground {
    background-image: url("../../assets/img/5jiaoyubeijing.png");
    /*width: 6%;*/
  }

  .personalSkills {
    background-image: url("../../assets/img/6gerenjineng.png");
  }

  .guanjian {
    background-image: url("../../assets/img/7gunjian.png");
  }

  .gongzuo {
    background-image: url("../../assets/img/8gongzuochengjiu.png");
  }

  .personalEvaluationText {
    padding: 8px 10%;
    text-indent: 2em;
    font-size: 14px;
  }

  .line {
    display: inline-block;
    width: 2%;
    height: 8px;
    background-color: #8fa3c6;
  }

  .line {
    margin-left: 2%;
  }

  .footer ul {
    width: 100%;
  }

  .footer li {
    float: left;
    height: 25px;
    margin-right: 1%;
  }

  .gray {
    width: 9%;
    background-color: #898a89;
  }

  .gold {
    width: 2%;
    background-color: #f4d321;
  }

  .blue {
    width: 5%;
    background-color: #b9c8e4;
  }

  .yellow {
    width: 7%;
    background-color: #b0ab17;
  }

  .deepBlue {
    background-color: #8fa3c6;
    width: 5%;
  }

  .black {
    background-color: #231815;
    width: 5%;
  }

  .footer li:nth-child(2) {
    width: 3%;
  }

  .footer li:nth-child(9) {
    width: 2%;
  }

  .footer li:nth-child(5) {
    width: 4%;
  }

  .footer li:nth-child(7) {
    width: 5%;
  }

  .footer li:nth-child(11) {
    width: 4%;
  }

  .footer li:last-child {
    margin-right: 0;
  }

  .basicInfoText,
  .workExperienceText,
  .certifiedText,
  .educationalBackgroundText,
  .personalSkillsText {
    /*margin-left: 4%;*/
    text-align: center;
    display: inline-block;
    height: 40px;
    line-height: 38px;
    /*background-color: #8fa3c6;*/
    color: #8fa3c6;
    font-size: 20px;
    padding: 0 2%;
  }

  .ExperienceList {
    margin-top: 30px;
  }

  .ExperienceList li {
    float: left;
    width: 50%;
    height: 40px;
    display: flex;
		column-gap: 14px;
    /*white-space: nowrap;*/
  }

  .ExperienceList span {
    position: relative;
    display: inline-block;
    text-align: right;
    white-space: nowrap;
    min-width: 45%;
  }

  .ExperienceList span::after {
    position: absolute;
    content: ":";
    right: -5%;
  }

  .ExperienceList i {
    width: 50%;
    padding-left: 4%;
    box-sizing: border-box;
  }

  .skill ul {
    padding-left: 1%;
  }

  .skill li {
    height: 40px;
  }

  .box {
    padding-bottom: 40px;
  }

  .el-table {
    margin: 0 auto;
    /*background-color: transparent;*/
    /*border: 1px solid #fff;*/
    font-size: 14px;
  }
  .jiahuan {
    font-weight: 600;

  }


  /*.el-table >>> tr {*/
  /*	background-color: transparent;*/
  /*}*/
  /*.el-table >>> .has-gutter th {*/
  /*	border-right: 1px solid #fff;*/
  /*	border-bottom: 1px solid #fff;*/
  /*	background-color: #ebecf0;*/
  /*	text-align: center;*/
  /*}*/
  /*.el-table >>> .el-table__row td {*/
  /*	text-align: center;*/
  /*}*/
  /*.el-table >>> .el-table__row:hover td {*/
  /*	background-color: transparent;*/
  /*}*/
</style>
<!--<style>-->
<!--.text-bold {-->
<!--font-weight: bold;-->
<!--font-size: 14px;-->
<!--}-->
<!--.resume-title {-->
<!--text-align: center;-->
<!--background: #1a75ca;-->
<!--}-->
<!--.resume-rise {-->
<!--font-weight: 900;-->
<!--font-style: normal;-->
<!--font-size: 28px;-->
<!--color: #ffffff;-->
<!--text-align: center;-->
<!--}-->
<!--/*大卡片的样式*/-->
<!--.box-card {-->
<!-- -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);-->
<!--box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);-->
<!--border: 1px solid #ebeef5;-->
<!--background-color: #fff;-->
<!--color: #303133;-->
<!-- -webkit-transition: 0.3s;-->
<!--transition: 0.3s;-->
<!--font-family: "Microsoft YaHei";-->

<!--border-radius: 4px;-->
<!--overflow: hidden;-->
<!--padding: 0 0 0 0;-->
<!--}-->
<!--.modify-form-font .el-form-item label {-->
<!--font-weight: bold;-->
<!--}-->
<!--/*文本域禁止拉伸*/-->
<!--.input_textarea .el-textarea__inner {-->
<!--resize: none;-->
<!--}-->
<!--</style>-->
